// @flow
import React from 'react';
import _ from 'lodash/fp';
import ActionConfirmation from '../../containers/ActionConfirmation/ActionConfirmation';
import './ProductRowList.css';

export type RowProps = {
  row: any,
  uniqueRowName: string,
  onSelect: Function,
  onRemove?: Function,
  isExtra: boolean,
};

const ProductRowListRow = ({row, onSelect, onRemove, isExtra, uniqueRowName}: RowProps) => {
  const hasNote = !!row.note;
  return [(
    <tr
      key={uniqueRowName}
      onClick={() => onSelect(row)}
      className="ProductRowList-product-row">
      <td rowSpan={hasNote ? 2 : 1}>
        {isExtra &&
          <div>
            <i className="fa  fa-user-plus"/>
          </div>
        }
      </td>
      <td>{row.productVariant.itemNumber}</td>
      <td className="ProductRowList-name">
        {row.product.name} - {row.productVariant.name}
      </td>
      <td className="ProductRowList-number-column">
        {row.orderedPrice === 0 ? 'Standard' : `${Math.round(row.orderedPrice)} kr`}
      </td>
      <td className="ProductRowList-number-column">
        {row.quantity}
      </td>
      <td onClick={e => e.stopPropagation()} rowSpan={hasNote ? 2 : 1}>
        {onRemove &&
          <ActionConfirmation
            id={uniqueRowName}
            className="secondary ProductRowList-remove-button"
            message="Vill du verkligen ta bort den här raden?"
            action={() => onRemove && onRemove(row)}>
            <i className="fa fa-trash"></i>
          </ActionConfirmation>
        }
      </td>
    </tr>
  ), ...(
    hasNote
      ? [(
        <tr
          key={`row-comment-${row.id}`}
          onClick={() => onSelect(row)}
          className="ProductRowList-comment">
          <td colSpan="7">
            <i className="fa fa-comment-o" />
            <span className="comment-text">{row.note}</span>
          </td>
        </tr>
      )]
      : []
  )];
};


export type Props = {
  allRowsByRoom: any[],
  onSelectRow: Function,
  onSelectExtraRow: Function,
  onRemoveExtraRow?: Function,
  canRemoveExtraRows?: boolean,
};

const ProductRowList = ({
  allRowsByRoom,
  onSelectRow,
  onSelectExtraRow,
  onRemoveExtraRow,
  canRemoveExtraRows,
}: Props) => (
  <div className="ProductRowList">
    <div className="row">
      <div className="column">
        <table className="table">
          <thead>
            <tr>
              <th/>
              <th>Artikelnr.</th>
              <th>Namn</th>
              <th className="ProductRowList-number-column">Pris</th>
              <th className="ProductRowList-number-column">Antal</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {_.map(room => ([
              <tr key={`room-${room.id}`}>
                <td
                  className="ProductRowList-room"
                  colSpan="7">
                  {room.name}
                </td>
              </tr>,
              ..._.flow(
                _.sortBy(['productVariant.itemNumber', 'id']),
                _.map(row =>
                  <ProductRowListRow
                    key={`extraProductRows-${row.id}`}
                    uniqueRowName={`linkedProductRows-${row.id}`}
                    row={row}
                    onSelect={onSelectExtraRow}
                    onRemove={canRemoveExtraRows ? onRemoveExtraRow : undefined}
                    isExtra={true}
                  />)
              )(room.extraProductRows),
              ..._.map(row =>
                <ProductRowListRow
                  key={`productRows-${row.id}`}
                  uniqueRowName={`productRows-${row.id}`}
                  row={row}
                  onSelect={onSelectRow}
                  isExtra={false}
                />, room.productRows),
            ]), allRowsByRoom)}
          </tbody>
        </table>
        {!allRowsByRoom.length &&
          <div className="callout secondary">
            Inga produkter
          </div>
        }
      </div>
    </div>
  </div>
);

export default ProductRowList;



// WEBPACK FOOTER //
// ./src/components/ProductRowList/ProductRowList.js